import { render, staticRenderFns } from "./PatientComplaints.vue?vue&type=template&id=10248798&scoped=true"
import script from "./PatientComplaints.vue?vue&type=script&lang=js"
export * from "./PatientComplaints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10248798",
  null
  
)

export default component.exports